import { render, staticRenderFns } from "./AllergenDietaryFilter.vue?vue&type=template&id=9aa8e5ae&scoped=true"
import script from "./AllergenDietaryFilter.vue?vue&type=script&lang=js"
export * from "./AllergenDietaryFilter.vue?vue&type=script&lang=js"
import style0 from "./AllergenDietaryFilter.vue?vue&type=style&index=0&id=9aa8e5ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aa8e5ae",
  null
  
)

export default component.exports